webpackJsonp([15],{

/***/ 1531:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SystemTasks_vue__ = __webpack_require__(1888);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_35b0f130_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SystemTasks_vue__ = __webpack_require__(2265);
function injectStyle (ssrContext) {
  __webpack_require__(2253)
  __webpack_require__(2255)
}
var normalizeComponent = __webpack_require__(951)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-35b0f130"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SystemTasks_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_35b0f130_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SystemTasks_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 1544:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Button_vue__ = __webpack_require__(1546);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_64c87b52_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Button_vue__ = __webpack_require__(1555);
function injectStyle (ssrContext) {
  __webpack_require__(1553)
}
var normalizeComponent = __webpack_require__(951)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-64c87b52"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Button_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_64c87b52_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Button_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1545:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Otwarte modale w kolejności otwierania. Esc zamyka tylko ostatni, żeby przy
// zagnieżdżonych modalach (np. wykres otwierany z modala szczegółów alarmów)
// nie zamykały się wszystkie naraz.
var openModals = [];

// Esc w otwartej liście vue-select / vue-multiselect zamyka samą listę; przy
// otwartym kalendarzu vue2-datepicker też nie ruszamy modala, żeby jednym
// klawiszem nie stracić wypełnionego formularza.
var OPEN_DROPDOWN = '.vs--open, .multiselect--active';
var OPEN_DATEPICKER = '.mx-datepicker-popup';

// Faza capture: sprawdzamy listy, zanim ich własna obsługa Esc je zamknie.
function onDocumentKeydown(event) {
    if (event.key !== 'Escape' && event.key !== 'Esc') return;

    var topModal = openModals[openModals.length - 1];
    if (topModal == null) return;

    var target = event.target;
    if (target instanceof Element && target.closest(OPEN_DROPDOWN) != null) return;
    if (document.querySelector(OPEN_DATEPICKER) != null) return;

    topModal.$emit('close');
}

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'Modal',
    props: {
        showDialog: {
            type: Boolean,
            required: false,
            default: false
        },
        maxWidth: {
            type: String,
            required: false,
            default: ''
        },
        title: {
            type: String,
            required: false,
            default: ''
        }
    },
    watch: {
        showDialog: {
            immediate: true,
            handler: function handler(isOpen) {
                isOpen ? this.registerOpen() : this.unregisterOpen();
            }
        }
    },
    beforeDestroy: function beforeDestroy() {
        this.unregisterOpen();
    },

    computed: {
        style: function style() {
            return 'max-width: ' + this.maxWidth;
        }
    },
    methods: {
        registerOpen: function registerOpen() {
            if (openModals.includes(this)) return;
            openModals.push(this);
            if (openModals.length === 1) {
                document.addEventListener('keydown', onDocumentKeydown, true);
            }
        },
        unregisterOpen: function unregisterOpen() {
            var index = openModals.indexOf(this);
            if (index === -1) return;
            openModals.splice(index, 1);
            if (openModals.length === 0) {
                document.removeEventListener('keydown', onDocumentKeydown, true);
            }
        }
    }
});

/***/ }),

/***/ 1546:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  emits: ['onClick'],
  props: {
    title: {
      type: String,
      default: '',
      required: false
    },
    buttonClass: {
      type: String,
      default: '',
      required: false
    }
  },
  data: function data() {
    return {};
  },

  methods: {
    onClick: function onClick() {
      this.$emit('onClick');
    }
  },
  computed: {
    buttonDef: function buttonDef() {
      return this.buttonClass === '' ? 'my-button' : '' + this.buttonClass;
    }
  }
});

/***/ }),

/***/ 1547:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Modal_vue__ = __webpack_require__(1545);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_330662f6_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Modal_vue__ = __webpack_require__(1551);
function injectStyle (ssrContext) {
  __webpack_require__(1549)
}
var normalizeComponent = __webpack_require__(951)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-330662f6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Modal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_330662f6_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Modal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1548:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _from = __webpack_require__(1558);

var _from2 = _interopRequireDefault(_from);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } else {
    return (0, _from2.default)(arr);
  }
};

/***/ }),

/***/ 1549:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1550);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1502)("6de141c4", content, true, {});

/***/ }),

/***/ 1550:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1501)(true);
// imports


// module
exports.push([module.i, ".modal[data-v-330662f6]{position:fixed;z-index:110;left:0;top:0;width:100%;height:100%;overflow:auto;display:block;background-color:rgba(0,0,0,.4)}.flex-container[data-v-330662f6]{height:100%;padding:0;margin:0;display:-webkit-box;display:-ms-flexbox;display:flex}.modal-content[data-v-330662f6]{margin:auto;background-color:#fefefe;border:unset;width:auto;z-index:1000;border-radius:5px;-webkit-box-shadow:0 4px 10px rgba(0,0,0,.2);box-shadow:0 4px 10px rgba(0,0,0,.2)}.modal-header[data-v-330662f6]{background-color:#34758e;width:100%;font-family:SourceSansProBold,sans-serif;font-size:16px;font-style:normal;font-weight:600;color:#fff}.close[data-v-330662f6]{color:#fff;float:right;font-size:28px;font-weight:700}.close[data-v-330662f6]:focus,.close[data-v-330662f6]:hover{color:#000;text-decoration:none;cursor:pointer}.widthClass[data-v-330662f6]{max-width:30%}#mdiv[data-v-330662f6]{width:25px;height:25px;cursor:pointer}.mdiv[data-v-330662f6]{height:25px;width:2px;margin-left:12px;background-color:#fff;-webkit-transform:rotate(45deg);transform:rotate(45deg);Z-index:1}.md[data-v-330662f6]{height:25px;width:2px;background-color:#fff;-webkit-transform:rotate(90deg);transform:rotate(90deg);Z-index:2}", "", {"version":3,"sources":["/Users/sleepingwarrior/BioControl/crfi-monitoring/UI/crfi_monitoring/src/components/Modal.vue"],"names":[],"mappings":"AACA,wBACI,eAAgB,AAGhB,YAAa,AACb,OAAQ,AACR,MAAO,AACP,WAAY,AACZ,YAAa,AACb,cAAe,AACf,cAAe,AACf,+BAAkC,CACrC,AACD,iCACI,YAAa,AACb,UAAW,AACX,SAAU,AACV,oBAAqB,AACrB,oBAAqB,AACrB,YAAc,CACjB,AAKD,gCACI,YAAa,AACb,yBAA0B,AAC1B,aAAc,AACd,WAAY,AACZ,aAAc,AACd,kBAAmB,AACnB,6CAAiD,AACzC,oCAAyC,CACpD,AACD,+BACI,yBAA2B,AAC3B,WAAY,AACZ,yCAA6C,AAC7C,eAAgB,AAChB,kBAAmB,AACnB,gBAAiB,AACjB,UAAa,CAChB,AACD,wBACI,WAAa,AACb,YAAa,AACb,eAAgB,AAChB,eAAkB,CACrB,AACD,4DAEI,WAAa,AACb,qBAAsB,AACtB,cAAgB,CACnB,AACD,6BACI,aAAe,CAClB,AAKD,uBACE,WAAY,AACZ,YAAa,AACb,cAAgB,CACjB,AACD,uBACE,YAAa,AACb,UAAW,AACX,iBAAkB,AAClB,sBAAwB,AACxB,gCAAiC,AACzB,wBAAyB,AACjC,SAAW,CACZ,AACD,qBACE,YAAa,AACb,UAAW,AACX,sBAAwB,AACxB,gCAAiC,AACzB,wBAAyB,AACjC,SAAW,CACZ","file":"Modal.vue","sourcesContent":["\n.modal[data-v-330662f6] {\n    position: fixed;\n    /* Nad paskiem górnym (.app-header, z-index 20) i mobilnym menu (99/100),\n       ale pod popupami doklejanymi do body (Syncfusion 1000, datepicker 2001). */\n    z-index: 110;\n    left: 0;\n    top: 0;\n    width: 100%;\n    height: 100%;\n    overflow: auto;\n    display: block;\n    background-color: rgba(0,0,0,0.4);\n}\n.flex-container[data-v-330662f6] {\n    height: 100%;\n    padding: 0;\n    margin: 0;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n}\n\n/* margin: auto zamiast align-items/justify-content: center — modal wyższy od\n   ekranu zaczyna się od góry i da się go przewinąć do nagłówka z krzyżykiem\n   (przy centrowaniu flexem jego górna część wystawała poza ekran). */\n.modal-content[data-v-330662f6] {\n    margin: auto;\n    background-color: #fefefe;\n    border: unset;\n    width: auto;\n    z-index: 1000;\n    border-radius: 5px;\n    -webkit-box-shadow: 0px 4px 10px rgba(0,0,0,0.2);\n            box-shadow: 0px 4px 10px rgba(0,0,0,0.2);\n}\n.modal-header[data-v-330662f6] {\n    background-color:  #34758E;\n    width: 100%;\n    font-family: \"SourceSansProBold\", sans-serif;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 600;\n    color: white;\n}\n.close[data-v-330662f6] {\n    color: white;\n    float: right;\n    font-size: 28px;\n    font-weight: bold;\n}\n.close[data-v-330662f6]:hover,\n.close[data-v-330662f6]:focus {\n    color: black;\n    text-decoration: none;\n    cursor: pointer;\n}\n.widthClass[data-v-330662f6] {\n    max-width: 30%;\n}\n.modal-slot[data-v-330662f6] {\n    /* margin-right: 10px;\n    margin-left: 10px; */\n}\n#mdiv[data-v-330662f6] {\n  width: 25px;\n  height: 25px;\n  cursor: pointer;\n}\n.mdiv[data-v-330662f6] {\n  height: 25px;\n  width: 2px;\n  margin-left: 12px;\n  background-color: white;\n  -webkit-transform: rotate(45deg);\n          transform: rotate(45deg);\n  Z-index: 1;\n}\n.md[data-v-330662f6] {\n  height: 25px;\n  width: 2px;\n  background-color: white;\n  -webkit-transform: rotate(90deg);\n          transform: rotate(90deg);\n  Z-index: 2;\n}\n\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1551:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showDialog)?_c('div',{staticClass:"modal flex-container"},[_c('div',{staticClass:"modal-content vertical",style:(_vm.style)},[_c('div',{staticClass:"modal-header"},[(_vm.title != undefined)?_c('p',{staticClass:"title"},[_vm._v(" "+_vm._s(_vm.title != null ? _vm.title : '')+" ")]):_vm._e(),_vm._v(" "),_c('div',{attrs:{"id":"mdiv"},on:{"click":function($event){return _vm.$emit('close')}}},[_vm._m(0)])]),_vm._v(" "),_c('div',{staticClass:"modal-slot"},[_vm._t("default")],2)])]):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mdiv"},[_c('div',{staticClass:"md"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1553:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1554);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1502)("9f84328e", content, true, {});

/***/ }),

/***/ 1554:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1501)(true);
// imports


// module
exports.push([module.i, ".my-button[data-v-64c87b52]{background:transparent;outline:none;border:none}", "", {"version":3,"sources":["/Users/sleepingwarrior/BioControl/crfi-monitoring/UI/crfi_monitoring/src/components/Button.vue"],"names":[],"mappings":"AACA,4BACI,uBAAwB,AACxB,aAAc,AACd,WAAa,CAChB","file":"Button.vue","sourcesContent":["\n.my-button[data-v-64c87b52] {\n    background: transparent;\n    outline: none;\n    border: none;\n}\n.my-button[data-v-64c87b52]:hover {\n}\n\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1555:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:_vm.buttonDef,attrs:{"type":"button"},on:{"click":_vm.onClick}},[_vm._v(_vm._s(_vm.$t(_vm.title))+"\n  "),_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1558:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1559), __esModule: true };

/***/ }),

/***/ 1559:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(960);
__webpack_require__(1560);
module.exports = __webpack_require__(105).Array.from;


/***/ }),

/***/ 1560:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ctx = __webpack_require__(222);
var $export = __webpack_require__(183);
var toObject = __webpack_require__(954);
var call = __webpack_require__(966);
var isArrayIter = __webpack_require__(967);
var toLength = __webpack_require__(446);
var createProperty = __webpack_require__(1561);
var getIterFn = __webpack_require__(962);

$export($export.S + $export.F * !__webpack_require__(968)(function (iter) { Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = getIterFn(O);
    var length, result, step, iterator;
    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for (result = new C(length); length > index; index++) {
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});


/***/ }),

/***/ 1561:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $defineProperty = __webpack_require__(184);
var createDesc = __webpack_require__(447);

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};


/***/ }),

/***/ 1562:
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),

/***/ 1564:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1569), __esModule: true };

/***/ }),

/***/ 1565:
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),

/***/ 1569:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1570);
module.exports = __webpack_require__(105).Object.assign;


/***/ }),

/***/ 1570:
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(183);

$export($export.S + $export.F, 'Object', { assign: __webpack_require__(1571) });


/***/ }),

/***/ 1571:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var DESCRIPTORS = __webpack_require__(154);
var getKeys = __webpack_require__(961);
var gOPS = __webpack_require__(1565);
var pIE = __webpack_require__(1562);
var toObject = __webpack_require__(954);
var IObject = __webpack_require__(963);
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(443)(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS || isEnum.call(S, key)) T[key] = S[key];
    }
  } return T;
} : $assign;


/***/ }),

/***/ 1576:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_uuid__ = __webpack_require__(1585);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_uuid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_uuid__);


//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
	name: "ProbablyOverflowingTextCell.vue",
	data: function data() {
		return {
			data: {},
			uuid: "0",
			init: false,
			interval: null
		};
	},

	computed: {
		text: function text() {
			return this.data[this.data.column.field];
		}
	},
	methods: {
		setVisible: function setVisible() {
			if (this.init) {
				try {
					var e = document.getElementById(this.uuid);
					var res = e.offsetWidth < e.scrollWidth;
					if (res) {
						e._tippy.enable();
					} else {
						e._tippy.disable();
					}
					clearInterval(this.interval);
				} catch (ignored) {}
			}
		}
	},
	mounted: function () {
		var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
			var _this = this;

			return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
				while (1) {
					switch (_context.prev = _context.next) {
						case 0:
							this.uuid = Object(__WEBPACK_IMPORTED_MODULE_2_uuid__["v4"])();
							this.init = true;
							this.interval = setInterval(function () {
								return _this.setVisible();
							}, 50);

						case 3:
						case "end":
							return _context.stop();
					}
				}
			}, _callee, this);
		}));

		function mounted() {
			return _ref.apply(this, arguments);
		}

		return mounted;
	}()
});

/***/ }),

/***/ 1577:
/***/ (function(module, exports) {

// Unique ID creation requires a high quality random # generator.  In the
// browser this is a little complicated due to unknown quality of Math.random()
// and inconsistent support for the `crypto` API.  We do the best we can via
// feature-detection

// getRandomValues needs to be invoked in a context where "this" is a Crypto
// implementation. Also, find the complete implementation of crypto on IE11.
var getRandomValues = (typeof(crypto) != 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto)) ||
                      (typeof(msCrypto) != 'undefined' && typeof window.msCrypto.getRandomValues == 'function' && msCrypto.getRandomValues.bind(msCrypto));

if (getRandomValues) {
  // WHATWG crypto RNG - http://wiki.whatwg.org/wiki/Crypto
  var rnds8 = new Uint8Array(16); // eslint-disable-line no-undef

  module.exports = function whatwgRNG() {
    getRandomValues(rnds8);
    return rnds8;
  };
} else {
  // Math.random()-based (RNG)
  //
  // If all else fails, use Math.random().  It's fast, but is of unspecified
  // quality.
  var rnds = new Array(16);

  module.exports = function mathRNG() {
    for (var i = 0, r; i < 16; i++) {
      if ((i & 0x03) === 0) r = Math.random() * 0x100000000;
      rnds[i] = r >>> ((i & 0x03) << 3) & 0xff;
    }

    return rnds;
  };
}


/***/ }),

/***/ 1578:
/***/ (function(module, exports) {

/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */
var byteToHex = [];
for (var i = 0; i < 256; ++i) {
  byteToHex[i] = (i + 0x100).toString(16).substr(1);
}

function bytesToUuid(buf, offset) {
  var i = offset || 0;
  var bth = byteToHex;
  // join used to fix memory issue caused by concatenation: https://bugs.chromium.org/p/v8/issues/detail?id=3175#c4
  return ([
    bth[buf[i++]], bth[buf[i++]],
    bth[buf[i++]], bth[buf[i++]], '-',
    bth[buf[i++]], bth[buf[i++]], '-',
    bth[buf[i++]], bth[buf[i++]], '-',
    bth[buf[i++]], bth[buf[i++]], '-',
    bth[buf[i++]], bth[buf[i++]],
    bth[buf[i++]], bth[buf[i++]],
    bth[buf[i++]], bth[buf[i++]]
  ]).join('');
}

module.exports = bytesToUuid;


/***/ }),

/***/ 1585:
/***/ (function(module, exports, __webpack_require__) {

var v1 = __webpack_require__(1591);
var v4 = __webpack_require__(1592);

var uuid = v4;
uuid.v1 = v1;
uuid.v4 = v4;

module.exports = uuid;


/***/ }),

/***/ 1586:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProbablyOverflowingTextCell_vue__ = __webpack_require__(1576);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6e2e6411_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProbablyOverflowingTextCell_vue__ = __webpack_require__(1593);
function injectStyle (ssrContext) {
  __webpack_require__(1587)
  __webpack_require__(1589)
}
var normalizeComponent = __webpack_require__(951)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6e2e6411"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProbablyOverflowingTextCell_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6e2e6411_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProbablyOverflowingTextCell_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1587:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1588);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1502)("28d11c4b", content, true, {});

/***/ }),

/***/ 1588:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1501)(true);
// imports


// module
exports.push([module.i, ".tippy-popper[x-placement^=bottom] .tippy-tooltip.customTheme-theme .tippy-arrow{border-bottom:8px solid #346f8b}", "", {"version":3,"sources":["/Users/sleepingwarrior/BioControl/crfi-monitoring/UI/crfi_monitoring/src/components/Systems/ProbablyOverflowingTextCell.vue"],"names":[],"mappings":"AACA,iFACC,+BAAiC,CACjC","file":"ProbablyOverflowingTextCell.vue","sourcesContent":["\n.tippy-popper[x-placement^=bottom] .tippy-tooltip.customTheme-theme .tippy-arrow {\n\tborder-bottom: 8px solid #346F8B;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1589:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1590);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1502)("42116436", content, true, {});

/***/ }),

/***/ 1590:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1501)(true);
// imports


// module
exports.push([module.i, ".tippy-tooltip.customTheme-theme[data-v-6e2e6411]{background-color:#346f8b}", "", {"version":3,"sources":["/Users/sleepingwarrior/BioControl/crfi-monitoring/UI/crfi_monitoring/src/components/Systems/ProbablyOverflowingTextCell.vue"],"names":[],"mappings":"AACA,kDACC,wBAA0B,CAC1B","file":"ProbablyOverflowingTextCell.vue","sourcesContent":["\n.tippy-tooltip.customTheme-theme[data-v-6e2e6411] {\n\tbackground-color: #346F8B;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1591:
/***/ (function(module, exports, __webpack_require__) {

var rng = __webpack_require__(1577);
var bytesToUuid = __webpack_require__(1578);

// **`v1()` - Generate time-based UUID**
//
// Inspired by https://github.com/LiosK/UUID.js
// and http://docs.python.org/library/uuid.html

var _nodeId;
var _clockseq;

// Previous uuid creation time
var _lastMSecs = 0;
var _lastNSecs = 0;

// See https://github.com/uuidjs/uuid for API details
function v1(options, buf, offset) {
  var i = buf && offset || 0;
  var b = buf || [];

  options = options || {};
  var node = options.node || _nodeId;
  var clockseq = options.clockseq !== undefined ? options.clockseq : _clockseq;

  // node and clockseq need to be initialized to random values if they're not
  // specified.  We do this lazily to minimize issues related to insufficient
  // system entropy.  See #189
  if (node == null || clockseq == null) {
    var seedBytes = rng();
    if (node == null) {
      // Per 4.5, create and 48-bit node id, (47 random bits + multicast bit = 1)
      node = _nodeId = [
        seedBytes[0] | 0x01,
        seedBytes[1], seedBytes[2], seedBytes[3], seedBytes[4], seedBytes[5]
      ];
    }
    if (clockseq == null) {
      // Per 4.2.2, randomize (14 bit) clockseq
      clockseq = _clockseq = (seedBytes[6] << 8 | seedBytes[7]) & 0x3fff;
    }
  }

  // UUID timestamps are 100 nano-second units since the Gregorian epoch,
  // (1582-10-15 00:00).  JSNumbers aren't precise enough for this, so
  // time is handled internally as 'msecs' (integer milliseconds) and 'nsecs'
  // (100-nanoseconds offset from msecs) since unix epoch, 1970-01-01 00:00.
  var msecs = options.msecs !== undefined ? options.msecs : new Date().getTime();

  // Per 4.2.1.2, use count of uuid's generated during the current clock
  // cycle to simulate higher resolution clock
  var nsecs = options.nsecs !== undefined ? options.nsecs : _lastNSecs + 1;

  // Time since last uuid creation (in msecs)
  var dt = (msecs - _lastMSecs) + (nsecs - _lastNSecs)/10000;

  // Per 4.2.1.2, Bump clockseq on clock regression
  if (dt < 0 && options.clockseq === undefined) {
    clockseq = clockseq + 1 & 0x3fff;
  }

  // Reset nsecs if clock regresses (new clockseq) or we've moved onto a new
  // time interval
  if ((dt < 0 || msecs > _lastMSecs) && options.nsecs === undefined) {
    nsecs = 0;
  }

  // Per 4.2.1.2 Throw error if too many uuids are requested
  if (nsecs >= 10000) {
    throw new Error('uuid.v1(): Can\'t create more than 10M uuids/sec');
  }

  _lastMSecs = msecs;
  _lastNSecs = nsecs;
  _clockseq = clockseq;

  // Per 4.1.4 - Convert from unix epoch to Gregorian epoch
  msecs += 12219292800000;

  // `time_low`
  var tl = ((msecs & 0xfffffff) * 10000 + nsecs) % 0x100000000;
  b[i++] = tl >>> 24 & 0xff;
  b[i++] = tl >>> 16 & 0xff;
  b[i++] = tl >>> 8 & 0xff;
  b[i++] = tl & 0xff;

  // `time_mid`
  var tmh = (msecs / 0x100000000 * 10000) & 0xfffffff;
  b[i++] = tmh >>> 8 & 0xff;
  b[i++] = tmh & 0xff;

  // `time_high_and_version`
  b[i++] = tmh >>> 24 & 0xf | 0x10; // include version
  b[i++] = tmh >>> 16 & 0xff;

  // `clock_seq_hi_and_reserved` (Per 4.2.2 - include variant)
  b[i++] = clockseq >>> 8 | 0x80;

  // `clock_seq_low`
  b[i++] = clockseq & 0xff;

  // `node`
  for (var n = 0; n < 6; ++n) {
    b[i + n] = node[n];
  }

  return buf ? buf : bytesToUuid(b);
}

module.exports = v1;


/***/ }),

/***/ 1592:
/***/ (function(module, exports, __webpack_require__) {

var rng = __webpack_require__(1577);
var bytesToUuid = __webpack_require__(1578);

function v4(options, buf, offset) {
  var i = buf && offset || 0;

  if (typeof(options) == 'string') {
    buf = options === 'binary' ? new Array(16) : null;
    options = null;
  }
  options = options || {};

  var rnds = options.random || (options.rng || rng)();

  // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
  rnds[6] = (rnds[6] & 0x0f) | 0x40;
  rnds[8] = (rnds[8] & 0x3f) | 0x80;

  // Copy bytes to buffer, if provided
  if (buf) {
    for (var ii = 0; ii < 16; ++ii) {
      buf[i + ii] = rnds[ii];
    }
  }

  return buf || bytesToUuid(rnds);
}

module.exports = v4;


/***/ }),

/***/ 1593:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{directives:[{name:"tippy",rawName:"v-tippy",value:({ theme : 'customTheme', placement : 'bottom-start', arrow : true }),expression:"{ theme : 'customTheme', placement : 'bottom-start', arrow : true }"}],staticStyle:{"text-overflow":"ellipsis","width":"100%","overflow":"hidden"},attrs:{"id":_vm.uuid,"content":_vm.text}},[_vm._v("\n\t\t"+_vm._s(_vm.text)+"\n\t")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1655:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1656), __esModule: true };

/***/ }),

/***/ 1656:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1657);
module.exports = __webpack_require__(105).Object.keys;


/***/ }),

/***/ 1657:
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 Object.keys(O)
var toObject = __webpack_require__(954);
var $keys = __webpack_require__(961);

__webpack_require__(1658)('keys', function () {
  return function keys(it) {
    return $keys(toObject(it));
  };
});


/***/ }),

/***/ 1658:
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__(183);
var core = __webpack_require__(105);
var fails = __webpack_require__(443);
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};


/***/ }),

/***/ 1688:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjUiIGhlaWdodD0iMjUiIHZpZXdCb3g9IjAgMCAyNSAyNSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iMTIuNSIgY3k9IjEyLjUiIHI9IjEyIiBmaWxsPSJ3aGl0ZSIgc3Ryb2tlPSJibGFjayIvPgo8bGluZSB4MT0iNSIgeTE9IjEyIiB4Mj0iMjAiIHkyPSIxMiIgc3Ryb2tlPSJibGFjayIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiLz4KPC9zdmc+Cg=="

/***/ }),

/***/ 1888:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(1548);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__syncfusion_ej2_vue_grids__ = __webpack_require__(953);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__api_api__ = __webpack_require__(952);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Systems_DismissAlarmModal_vue__ = __webpack_require__(2257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Systems_ProbablyOverflowingTextCell_vue__ = __webpack_require__(1586);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Modal_vue__ = __webpack_require__(1547);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Settings_Tasks_TaskProblemModal_vue__ = __webpack_require__(2261);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










var context = null;

/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        systemName: {
            required: false,
            type: String
        },
        systemId: {
            required: false,
            type: String
        },
        priority: {
            required: false,
            type: String
        }
    },
    provide: {
        grid: [__WEBPACK_IMPORTED_MODULE_4__syncfusion_ej2_vue_grids__["l" /* Sort */], __WEBPACK_IMPORTED_MODULE_4__syncfusion_ej2_vue_grids__["i" /* Page */], __WEBPACK_IMPORTED_MODULE_4__syncfusion_ej2_vue_grids__["g" /* Filter */], __WEBPACK_IMPORTED_MODULE_4__syncfusion_ej2_vue_grids__["m" /* Toolbar */], __WEBPACK_IMPORTED_MODULE_4__syncfusion_ej2_vue_grids__["k" /* Search */], __WEBPACK_IMPORTED_MODULE_4__syncfusion_ej2_vue_grids__["b" /* CommandColumn */], __WEBPACK_IMPORTED_MODULE_4__syncfusion_ej2_vue_grids__["j" /* PdfExport */], __WEBPACK_IMPORTED_MODULE_4__syncfusion_ej2_vue_grids__["CsvExport"], __WEBPACK_IMPORTED_MODULE_4__syncfusion_ej2_vue_grids__["f" /* ExcelExport */], __WEBPACK_IMPORTED_MODULE_4__syncfusion_ej2_vue_grids__["d" /* DetailRow */]]
    },
    components: {
        DismissAlarmModal: __WEBPACK_IMPORTED_MODULE_6__components_Systems_DismissAlarmModal_vue__["a" /* default */],
        ProbablyOverflowingTextCell: __WEBPACK_IMPORTED_MODULE_7__components_Systems_ProbablyOverflowingTextCell_vue__["a" /* default */],
        Modal: __WEBPACK_IMPORTED_MODULE_8__components_Modal_vue__["a" /* default */],
        TaskProblemModal: __WEBPACK_IMPORTED_MODULE_9__components_Settings_Tasks_TaskProblemModal_vue__["a" /* default */]
    },
    computed: {
        toolbar: function toolbar() {
            if (this.$store.getters.isUser) {
                return [{
                    text: this.$t("ClearFilter"),
                    id: "clear-filters",
                    prefixIcon: "e-cancel",
                    align: "Right"
                }, {
                    text: this.showResolved ? this.$t("ShowUnresolvedTasks") : this.$t("ShowResolvedTasks"),
                    id: "toggle-resolved-tasks",
                    prefixIcon: "e-check",
                    align: "Right"
                }, // Updated button
                "Search"];
            }

            return [].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(!this.showResolved ? [{
                text: this.$t("DismissMany"),
                id: "dismiss-many",
                prefixIcon: "e-cancel",
                align: "Left"
            }] : []), [{
                text: this.$t("ClearFilter"),
                id: "clear-filters",
                prefixIcon: "e-cancel",
                align: "Right"
            }, {
                text: this.showResolved ? this.$t("ShowUnresolvedTasks") : this.$t("ShowResolvedTasks"),
                id: "toggle-resolved-tasks",
                prefixIcon: "e-check",
                align: "Right"
            }, // Updated button
            "Search"]);
        },
        notUser: function notUser() {
            return this.$store.getters.isAdmin || this.$store.getters.isService;
        }
    },
    data: function data() {
        return {
            data: [],
            childData: [],
            pageSettings: {
                pageSize: 100,
                pageSizes: [10, 50, 100, 500, 1000]
            },
            showResolved: false,
            selectionOptions: { type: "Multiple" },
            filterOptions: {
                type: "CheckBox",
                columns: this.priority != null ? [{
                    field: "priority",
                    matchCase: false,
                    operator: "equal",
                    value: this.priority
                }] : []
            },
            // Data wymaga filtru Menu - CheckBox listuje kazdy timestamp z dokladnoscia
            // do sekundy, wiec nie da sie nim filtrowac zakresem.
            dateFilterOptions: { type: "Menu" },
            customAttributes: { class: "customcss" },
            dateTimeFormatOptions: {
                format: "yyyy-MM-dd HH:mm:ss",
                type: "dateTime"
            },
            selectedObject: null,
            isSelectedGroup: false,
            modal: "NONE",
            childGrid: {
                queryString: "table_id",
                columns: [{
                    field: "name",
                    headerText: this.$i18n.t("Name"),
                    textAlign: "Left"
                }, {
                    field: "description",
                    headerText: this.$i18n.t("Description"),
                    textAlign: "Left",
                    template: function template() {
                        return {
                            template: {
                                extends: __WEBPACK_IMPORTED_MODULE_7__components_Systems_ProbablyOverflowingTextCell_vue__["a" /* default */]
                            }
                        };
                    }
                }, {
                    field: "createDate",
                    headerText: this.$i18n.t("CreateDate"),
                    textAlign: "Left",
                    type: "dateTime",
                    format: "yyyy-MM-dd HH:mm:ss"
                }, {
                    field: "endDate",
                    headerText: this.$i18n.t("EndDate"),
                    textAlign: "Left",
                    type: "dateTime",
                    format: "yyyy-MM-dd HH:mm:ss"
                }, {
                    field: "dismissDate",
                    visible: this.$store.getters.isAdmin || this.$store.getters.isService,
                    headerText: this.$i18n.t("Options"),
                    textAlign: "Left",
                    template: function template() {
                        return {
                            template: __WEBPACK_IMPORTED_MODULE_3_vue__["default"].component("optionsButtons", {
                                template: "\n                                        <button class='show-password-button' style=\"align-self: center;\" v-on:click=\"onClick('dismiss')\">" + context.$t("Dismiss") + "</button>\n                                    ",
                                data: function data() {
                                    return {
                                        data: {}
                                    };
                                },
                                methods: {
                                    onClick: function onClick(mode) {
                                        switch (mode) {
                                            case "dismiss":
                                                context.isSelectedGroup = true;
                                                context.selectedObject = this.data;
                                                context.modal = "DISMISS";
                                                break;
                                        }
                                    }
                                }
                            })
                        };
                    }
                }]
            },
            optionsButtons: function optionsButtons() {
                return {
                    template: __WEBPACK_IMPORTED_MODULE_3_vue__["default"].component("optionsButtons", {
                        template: "\n                        <div class=\"horizontal\">\n                            <button v-if=\"!showResolved\" class='show-password-button' style=\"align-self: center;\" v-on:click=\"onClick('dismiss')\">{{ $t('Dismiss') }}</button>\n                            <button v-if=\"!showResolved\" class='show-password-button' style=\"align-self: center; margin-left: 5px;\" v-on:click=\"onClick('problem')\">{{ $t('Problem') }}</button>\n                        </div>\n                    ",
                        data: function data() {
                            return {
                                data: {}
                            };
                        },
                        methods: {
                            onClick: function onClick(mode) {
                                switch (mode) {
                                    case "dismiss":
                                        context.modal = "DISMISS";
                                        context.selectedObject = this.data;
                                        break;
                                    case "problem":
                                        context.modal = "PROBLEM";
                                        context.selectedObject = this.data;
                                }
                            }
                        },
                        computed: {
                            showResolved: function showResolved() {
                                return context.showResolved;
                            }
                        }
                    })
                };
            },
            TextTemplate: function TextTemplate() {
                return {
                    template: {
                        extends: __WEBPACK_IMPORTED_MODULE_7__components_Systems_ProbablyOverflowingTextCell_vue__["a" /* default */]
                    }
                };
            }
        };
    },

    methods: {
        toDateOrNull: function toDateOrNull(value) {
            if (value == null) {
                return null;
            }

            var parsed = value instanceof Date ? value : new Date(value);

            if (isNaN(parsed.getTime()) || parsed < new Date("2001-01-01")) {
                return null;
            }

            return parsed;
        },
        getData: function getData() {
            var _this = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _this.$store.dispatch("set_loading", true);
                                _this.childData = [];

                                Object(__WEBPACK_IMPORTED_MODULE_5__api_api__["_79" /* getSystemTasks */])(_this.systemId, _this.showResolved).then(function (response) {
                                    _this.data = response.data;
                                    _this.data.forEach(function (el) {
                                        var minDate = new Date("2001-01-01");
                                        if (new Date(el.endDate) < minDate) {
                                            el.endDateString = "-";
                                        } else {
                                            el.endDateString = el.endDate.toDateTime();
                                        }
                                        if (el.unitNumber == null) {
                                            el.unitNumber = "-";
                                        }
                                        el.priority = [_this.$t("High"), _this.$t("Mid"), _this.$t("Low")][el.priority - 1];
                                        el.table_id = el.alarmName + "_" + el.unitNumber + "_" + el.createDate;
                                        // API zwraca daty jako stringi ISO, a kolumny typu dateTime
                                        // filtruja i sortuja tylko obiekty Date.
                                        el.createDate = _this.toDateOrNull(el.createDate);
                                        if (el.nestedAlarms != undefined && el.nestedAlarms != null) {
                                            var _childData;

                                            el.nestedAlarms.forEach(function (ne) {
                                                ne.table_id = el.table_id;
                                                ne.alarmTypeId = el.alarmTypeId;
                                                ne.createDate = _this.toDateOrNull(ne.createDate);
                                                ne.endDate = _this.toDateOrNull(ne.endDate);
                                            });
                                            (_childData = _this.childData).push.apply(_childData, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(el.nestedAlarms));
                                        }

                                        el.alarmName = _this.$t(el.alarmName);
                                    });

                                    // this.data.sort((b, a) => new Date(a.createDate) - new Date(b.createDate))
                                    _this.data.sort(function (b, a) {
                                        return b.alarmName.localeCompare(a.alarmName);
                                    });

                                    _this.$store.dispatch("set_loading", false);
                                });

                            case 3:
                            case "end":
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        },

        dataBound: function dataBound() {
            this.$refs.grid.autoFitColumns();
        },
        toolbarClick: function toolbarClick(args) {
            switch (args.item.id) {
                case "clear-filters":
                    this.$refs.grid.clearFiltering();
                    break;
                case "dismiss-many":
                    this.dismissManySetup();
                    break;
                case "toggle-resolved-tasks":
                    this.showResolved = !this.showResolved;
                    args.item.text = this.showResolved ? this.$t("ShowUnresolvedTasks") : this.$t("ShowResolvedTasks");
                    this.getData();
                    break;
            }
        },
        // Zadanie bez zagnieżdżonych alarmów nie ma czego rozwijać. Komórka
        // rozwijania zostaje z klasą paczki, więc ma tę samą szerokość, tło,
        // obramowanie i hover co pozostałe wiersze (w obu motywach) — dopisujemy
        // tylko task-no-details, która chowa strzałkę i blokuje klik (style niżej).
        rowDataBound: function rowDataBound(args) {
            var hasNestedAlarms = args.data.nestedAlarms != null && args.data.nestedAlarms.length > 0;
            if (hasNestedAlarms) return;

            var expandCell = args.row.querySelector(".e-detailrowcollapse");
            if (expandCell) expandCell.classList.add("task-no-details");
        },
        dismissManySetup: function dismissManySetup() {
            this.modal = "DISMISSMANY";
            this.selectedObject = this.$refs.grid.getSelectedRecords();
        },
        onDetailDataBound: function onDetailDataBound(args) {
            args.detailElement.querySelector(".e-grid").ej2_instances[0].dataSource = this.childData.filter(function (el) {
                return el.table_id == args.data.table_id;
            });
        },
        close: function close() {
            this.modal = "NONE";
            this.selectedObject = null;
            this.isSelectedGroup = false;
        },
        closeAndReload: function closeAndReload() {
            this.modal = "NONE";

            this.selectedObject = null;
            this.isSelectedGroup = false;

            this.getData();
        },
        saveAndReload: function saveAndReload() {
            var _this2 = this;

            var objToSend = {
                Annotation: "Autodismissed by creating problem.",
                AlarmsId: [],
                AlarmTypeId: -1
            };

            if (this.selectedObject.nestedAlarms != null) {
                var _objToSend$AlarmsId;

                (_objToSend$AlarmsId = objToSend.AlarmsId).push.apply(_objToSend$AlarmsId, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(this.selectedObject.nestedAlarms.map(function (m) {
                    return m.id;
                })));
                objToSend.AlarmTypeId = this.selectedObject.alarmTypeId;
            } else {
                objToSend.AlarmsId.push(this.selectedObject.id);
                objToSend.AlarmTypeId = this.selectedObject.alarmTypeId;
            }

            Object(__WEBPACK_IMPORTED_MODULE_5__api_api__["H" /* dismissAlarms */])(this.systemId, objToSend).then(function () {
                _this2.$emit("dismissed");
            }).catch(function (err) {
                _this2.error = err.response.data.error;
            });

            this.closeAndReload();
        }
    },
    mounted: function mounted() {
        context = this;
        this.getData();
    }
});

/***/ }),

/***/ 1889:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(1548);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_api__ = __webpack_require__(952);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Button_vue__ = __webpack_require__(1544);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        isMany: {
            required: false,
            default: false,
            type: Boolean
        },
        isGroup: {
            required: false,
            default: false,
            type: Boolean
        },
        toDismiss: {
            required: true
        },
        systemId: {
            type: String,
            required: true
        }
    },
    components: {
        Button: __WEBPACK_IMPORTED_MODULE_2__Button_vue__["a" /* default */]
    },
    data: function data() {
        return {
            annotation: '',
            error: ''
        };
    },

    methods: {
        dismiss: function dismiss() {
            var _this = this;

            var objToSend = {
                Annotation: this.annotation,
                AlarmsId: [],
                AlarmTypeId: -1
            };
            if (this.isMany) {
                for (var i = 0; i < this.toDismiss.length; i++) {
                    if (this.toDismiss[i].nestedAlarms != null) {
                        var _objToSend$AlarmsId;

                        (_objToSend$AlarmsId = objToSend.AlarmsId).push.apply(_objToSend$AlarmsId, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.toDismiss[i].nestedAlarms.map(function (m) {
                            return m.id;
                        })));
                    } else {
                        objToSend.AlarmsId.push(this.toDismiss[i].id);
                    }
                }
            } else if (this.isGroup) {
                objToSend.AlarmsId.push(this.toDismiss.id);
                objToSend.AlarmTypeId = this.toDismiss.alarmTypeId;
            } else {
                if (this.toDismiss.nestedAlarms != null) {
                    var _objToSend$AlarmsId2;

                    (_objToSend$AlarmsId2 = objToSend.AlarmsId).push.apply(_objToSend$AlarmsId2, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.toDismiss.nestedAlarms.map(function (m) {
                        return m.id;
                    })));
                    objToSend.AlarmTypeId = this.toDismiss.alarmTypeId;
                } else {
                    objToSend.AlarmsId.push(this.toDismiss.id);
                    objToSend.AlarmTypeId = this.toDismiss.alarmTypeId;
                }
            }

            if (this.isMany) {
                Object(__WEBPACK_IMPORTED_MODULE_1__api_api__["I" /* dismissManyAlarms */])(this.systemId, objToSend).then(function () {
                    _this.$emit('dismissed');
                }).catch(function (err) {
                    _this.error = err.response.data.error;
                });
            } else {
                Object(__WEBPACK_IMPORTED_MODULE_1__api_api__["H" /* dismissAlarms */])(this.systemId, objToSend).then(function () {
                    _this.$emit('dismissed');
                }).catch(function (err) {
                    _this.error = err.response.data.error;
                });
            }
        }
    },
    mounted: function mounted() {}
});

/***/ }),

/***/ 1890:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(1655);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(1564);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__(294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api_api__ = __webpack_require__(952);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Button_vue__ = __webpack_require__(1544);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_moment__);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        task: {
            required: false,
            default: null,
            type: Object
        },
        systemId: {
            required: false,
            default: null,
            type: String
        },
        systemName: {
            required: true,
            default: null,
            type: String
        }
    },
    components: {
        Button: __WEBPACK_IMPORTED_MODULE_5__components_Button_vue__["a" /* default */]
    },
    data: function data() {
        return {
            selectedObject: {
                deviceId: null,
                systemId: null,
                visitId: null,
                description: null,
                title: null
            },

            error: '',
            devices: [],
            photos: [],
            activePhotoIndex: 0
        };
    },

    methods: {
        getData: function getData() {
            var _this = this;

            return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee() {
                var desc, device;
                return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                desc = _this.task.description == null ? _this.task.nestedAlarms[0].description : _this.task.description;


                                _this.selectedObject = {
                                    systemId: _this.systemId,
                                    description: desc,
                                    title: 'Task ' + _this.task.alarmName + ' from ' + _this.task.createDate.toDateTime(),
                                    deviceId: ''
                                };

                                _context.next = 4;
                                return Object(__WEBPACK_IMPORTED_MODULE_4__api_api__["_52" /* getShortDevicesList */])(_this.systemId);

                            case 4:
                                _this.devices = _context.sent;
                                device = _this.devices.filter(function (x) {
                                    return x.unitNumber == _this.task.unitNumber;
                                });

                                // console.log(device.length)

                                if (device.length != 0) {
                                    // console.log(`${device[0].unitNumber} (${device[0].type})`)
                                    _this.selectedObject.deviceId = device[0].unitNumber + ' (' + device[0].type + ')';
                                }

                            case 7:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        },
        save: function save() {
            var _this2 = this;

            return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee2() {
                var toSend, element, form, keys, i, photosSrc, _i;

                return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _this2.validate();

                                if (!(_this2.error != '')) {
                                    _context2.next = 3;
                                    break;
                                }

                                return _context2.abrupt('return');

                            case 3:
                                toSend = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, _this2.selectedObject);

                                toSend.reportedDate = __WEBPACK_IMPORTED_MODULE_6_moment___default()(Date.now()).format('YYYY-MM-DD');
                                toSend.creatorId = _this2.$store.getters.user.userId;

                                if (_this2.devices.length > 0) {
                                    element = _this2.devices.filter(function (x) {
                                        return x.number == _this2.selectedObject.deviceId;
                                    });

                                    if (element.length > 0) {
                                        toSend.deviceId = element[0].id;
                                    }
                                }

                                form = new FormData();
                                keys = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(toSend);

                                for (i = 0; i < keys.length; i++) {
                                    form.append(keys[i], toSend[keys[i]]);
                                }

                                photosSrc = _this2.photos.map(function (x) {
                                    return x.src;
                                });

                                for (_i = 0; _i < photosSrc.length; _i++) {
                                    form.append("resources", photosSrc[_i]);
                                }

                                _context2.next = 14;
                                return Object(__WEBPACK_IMPORTED_MODULE_4__api_api__["_110" /* saveProblem */])(form);

                            case 14:
                                _this2.$emit('saved');

                            case 15:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this2);
            }))();
        },
        sortSystemsByName: function sortSystemsByName(a, b) {
            return a.name.localeCompare(b.name, undefined, {
                numeric: true,
                sensitivity: 'base'
            });
        },
        deletePhoto: function deletePhoto(index) {
            this.activePhotoIndex = this.activePhotoIndex == index ? index > 1 ? index - 1 : 0 : this.activePhotoIndex;
            this.photos.splice(index, 1);
        },
        changePhoto: function changePhoto(direction) {
            if (direction > 0) {
                if (this.activePhotoIndex + 1 < this.photos.length) {
                    this.activePhotoIndex++;
                } else {
                    this.activePhotoIndex = 0;
                }
            } else {
                if (this.activePhotoIndex > 0) {
                    this.activePhotoIndex--;
                } else {
                    this.activePhotoIndex = this.photos.length - 1;
                }
            }
        },
        addPhoto: function addPhoto(e) {
            for (var i = 0; i < e.target.files.length; i++) {
                var photo = URL.createObjectURL(e.target.files[i]);
                this.photos.push({
                    src: e.target.files[i],
                    url: photo
                });
            }
            this.activePhotoIndex = this.photos.length - 1;
        },
        validate: function validate() {
            this.error = "";

            if (this.selectedObject.title == null || this.selectedObject.title.trim() == '') {
                this.error = this.$t("SelectTitleBeforeSaving");
                return;
            }

            if (this.selectedObject.description == null || this.selectedObject.description.trim() == '') {
                this.error = this.$t("SelectDescriptionBeforeSaving");
                return;
            }
        }
    },
    mounted: function mounted() {
        var _this3 = this;

        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee3() {
            return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
                while (1) {
                    switch (_context3.prev = _context3.next) {
                        case 0:
                            _this3.getData();

                        case 1:
                        case 'end':
                            return _context3.stop();
                    }
                }
            }, _callee3, _this3);
        }))();
    }
});

/***/ }),

/***/ 2253:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2254);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1502)("02b12713", content, true, {});

/***/ }),

/***/ 2254:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1501)(true);
// imports


// module
exports.push([module.i, ".e-grid .e-headercell.customcss[data-v-35b0f130]{padding:0 5px}", "", {"version":3,"sources":["/Users/sleepingwarrior/BioControl/crfi-monitoring/UI/crfi_monitoring/src/views/System/SystemTasks.vue"],"names":[],"mappings":"AACA,iDACI,aAAqB,CACxB","file":"SystemTasks.vue","sourcesContent":["\n.e-grid .e-headercell.customcss[data-v-35b0f130] {\n    padding: 0 5px 0 5px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 2255:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2256);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1502)("f9b3b932", content, true, {});

/***/ }),

/***/ 2256:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1501)(true);
// imports


// module
exports.push([module.i, ".tippy-tooltip.customTheme-theme{background-color:#346f8b}.tippy-popper[x-placement^=left] .tippy-tooltip.customTheme-theme .tippy-arrow{border-left:8px solid #346f8b}.e-grid td.e-detailrowcollapse.task-no-details{pointer-events:none;cursor:default}.e-grid td.e-detailrowcollapse.task-no-details>*{visibility:hidden}.show-password-button{border:1px solid #ddd;padding:5px 10px;background:none}.show-password-button:hover{background:#bbb}", "", {"version":3,"sources":["/Users/sleepingwarrior/BioControl/crfi-monitoring/UI/crfi_monitoring/src/views/System/SystemTasks.vue"],"names":[],"mappings":"AACA,iCACI,wBAA0B,CAC7B,AACD,+EAGI,6BAA+B,CAClC,AAOD,+CACI,oBAAqB,AACrB,cAAgB,CACnB,AACD,iDACI,iBAAmB,CACtB,AACD,sBACI,sBAAuB,AACvB,iBAAkB,AAClB,eAAiB,CACpB,AACD,4BACI,eAAoB,CACvB","file":"SystemTasks.vue","sourcesContent":["\n.tippy-tooltip.customTheme-theme {\n    background-color: #346f8b;\n}\n.tippy-popper[x-placement^=\"left\"]\n    .tippy-tooltip.customTheme-theme\n    .tippy-arrow {\n    border-left: 8px solid #346f8b;\n}\n\n/*\n * Pusta komórka rozwijania (rowDataBound). Klik przechodzi przez komórkę na\n * wiersz, a paczka rozwija tylko po kliknięciu w td (closest(target, 'td')),\n * więc pusta tabela zagnieżdżona się nie otworzy.\n */\n.e-grid td.e-detailrowcollapse.task-no-details {\n    pointer-events: none;\n    cursor: default;\n}\n.e-grid td.e-detailrowcollapse.task-no-details > * {\n    visibility: hidden;\n}\n.show-password-button {\n    border: 1px #ddd solid;\n    padding: 5px 10px;\n    background: none;\n}\n.show-password-button:hover {\n    background: #bbbbbb;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 2257:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DismissAlarmModal_vue__ = __webpack_require__(1889);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1d3fbdaf_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DismissAlarmModal_vue__ = __webpack_require__(2260);
function injectStyle (ssrContext) {
  __webpack_require__(2258)
}
var normalizeComponent = __webpack_require__(951)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1d3fbdaf"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DismissAlarmModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1d3fbdaf_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DismissAlarmModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 2258:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2259);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1502)("24989299", content, true, {});

/***/ }),

/***/ 2259:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1501)(true);
// imports


// module
exports.push([module.i, ".error[data-v-1d3fbdaf]{text-align:left!important;color:#fd8282;font-size:11px;font-weight:700;font-family:Open Sans,sans-serif!important;font-style:normal!important;font-weight:400!important}#info-container[data-v-1d3fbdaf]{padding:20px;background:#fff;border:1px solid #efefef;-webkit-box-sizing:border-box;box-sizing:border-box;-webkit-box-shadow:0 0 20px rgba(0,0,0,.1);box-shadow:0 0 20px rgba(0,0,0,.1);border-radius:5px 0 0 5px;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.info-field[data-v-1d3fbdaf]{border-bottom:1px solid #e9e9e9;margin-bottom:12px;margin-top:12px}.info-field-title[data-v-1d3fbdaf]{font-style:normal;font-weight:600;font-size:12px;line-height:16px;color:#272727;margin:0}.info-field-row[data-v-1d3fbdaf]{width:100%;margin:0;padding-bottom:5px;display:grid;grid-template-columns:30% 70%}.info-field-value[data-v-1d3fbdaf]{font-style:normal;font-weight:400;font-size:12px;line-height:16px;color:#272727}.section-title[data-v-1d3fbdaf]{font-weight:700}textarea[data-v-1d3fbdaf]{border:none;width:100%}textarea[data-v-1d3fbdaf]:focus{border-bottom:1px solid #0095b2;outline:none}", "", {"version":3,"sources":["/Users/sleepingwarrior/BioControl/crfi-monitoring/UI/crfi_monitoring/src/components/Systems/DismissAlarmModal.vue"],"names":[],"mappings":"AACA,wBACI,0BAA4B,AAC5B,cAAe,AACf,eAAgB,AAChB,gBAAkB,AAClB,2CAAgD,AAChD,4BAA8B,AAC9B,yBAA4B,CAC/B,AACD,iCACI,aAAc,AACd,gBAAoB,AACpB,yBAA0B,AAC1B,8BAA+B,AACvB,sBAAuB,AAC/B,2CAAoD,AAC5C,mCAA4C,AACpD,0BAA+B,AAC/B,yBAA0B,AACtB,sBAAuB,AACnB,8BAA+B,AACvC,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,4BAA6B,AAC7B,6BAA8B,AAC1B,0BAA2B,AACvB,qBAAuB,CAClC,AACD,6BACI,gCAAiC,AACjC,mBAAoB,AACpB,eAAiB,CACpB,AACD,mCACI,kBAAmB,AACnB,gBAAiB,AACjB,eAAgB,AAChB,iBAAkB,AAElB,cAAe,AACf,QAAU,CACb,AACD,iCACI,WAAY,AACZ,SAAU,AACV,mBAAoB,AACpB,aAAc,AACd,6BAA+B,CAClC,AACD,mCACI,kBAAmB,AACnB,gBAAoB,AACpB,eAAgB,AAChB,iBAAkB,AAElB,aAAe,CAClB,AACD,gCACI,eAAkB,CACrB,AACD,0BACI,YAAa,AACb,UAAY,CACf,AACD,gCACI,gCAAiC,AACjC,YAAc,CACjB","file":"DismissAlarmModal.vue","sourcesContent":["\n.error[data-v-1d3fbdaf] {\n    text-align: left !important;\n    color: #FD8282;\n    font-size: 11px;\n    font-weight: bold;\n    font-family: 'Open Sans', sans-serif !important;\n    font-style: normal !important;\n    font-weight: 400 !important;\n}\n#info-container[data-v-1d3fbdaf] {\n    padding: 20px;\n    background: #FFFFFF;\n    border: 1px solid #EFEFEF;\n    -webkit-box-sizing: border-box;\n            box-sizing: border-box;\n    -webkit-box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.1);\n            box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.1);\n    border-radius: 5px 0px 0px 5px;\n    -webkit-box-pack: justify;\n        -ms-flex-pack: justify;\n            justify-content: space-between;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n        -ms-flex-direction: column;\n            flex-direction: column;\n}\n.info-field[data-v-1d3fbdaf] {\n    border-bottom: 1px solid #E9E9E9;\n    margin-bottom: 12px;\n    margin-top: 12px;\n}\n.info-field-title[data-v-1d3fbdaf] {\n    font-style: normal;\n    font-weight: 600;\n    font-size: 12px;\n    line-height: 16px;\n\n    color: #272727;\n    margin: 0;\n}\n.info-field-row[data-v-1d3fbdaf] {\n    width: 100%;\n    margin: 0;\n    padding-bottom: 5px;\n    display: grid;\n    grid-template-columns: 30% 70%;\n}\n.info-field-value[data-v-1d3fbdaf] {\n    font-style: normal;\n    font-weight: normal;\n    font-size: 12px;\n    line-height: 16px;\n\n    color: #272727;\n}\n.section-title[data-v-1d3fbdaf] {\n    font-weight: bold;\n}\ntextarea[data-v-1d3fbdaf] {\n    border: none;\n    width: 100%;\n}\ntextarea[data-v-1d3fbdaf]:focus {\n    border-bottom: 1px solid #0095b2;\n    outline: none;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 2260:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"width":"50vw","min-width":"350px"},attrs:{"id":"info-container"}},[_c('div',[_c('div',[_c('div',{staticClass:"info-field horizontal"},[_c('tr',{staticClass:"info-field-row"},[_c('td',[_c('p',{staticClass:"info-field-title"},[_vm._v(_vm._s(_vm.$t('Annotation')))])]),_vm._v(" "),_c('td',{staticClass:"info-field-value"},[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.annotation),expression:"annotation"}],attrs:{"type":"text","placeholder":_vm.$t('Annotation')},domProps:{"value":(_vm.annotation)},on:{"input":function($event){if($event.target.composing){ return; }_vm.annotation=$event.target.value}}})])])]),_vm._v(" "),_c('div',[(_vm.error != '')?_c('div',{staticClass:"error"},[_vm._v(_vm._s(_vm.error))]):_vm._e()])])]),_vm._v(" "),_c('div',{staticStyle:{"align-self":"center"}},[_c('Button',{staticStyle:{"width":"300px","align-self":"center"},attrs:{"title":_vm.$t('Save'),"buttonClass":"save-button semi-bold"},on:{"onClick":_vm.dismiss}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 2261:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TaskProblemModal_vue__ = __webpack_require__(1890);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7e69a01c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TaskProblemModal_vue__ = __webpack_require__(2264);
function injectStyle (ssrContext) {
  __webpack_require__(2262)
}
var normalizeComponent = __webpack_require__(951)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7e69a01c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TaskProblemModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7e69a01c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TaskProblemModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 2262:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2263);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1502)("22f36671", content, true, {});

/***/ }),

/***/ 2263:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1501)(true);
// imports


// module
exports.push([module.i, ".gallery-container[data-v-7e69a01c]{background:#f9f9f9;-webkit-box-shadow:0 0 40px rgba(53,110,138,.25);box-shadow:0 0 40px rgba(53,110,138,.25);border-radius:5px}.section-title[data-v-7e69a01c]{text-align:center}.info-field[data-v-7e69a01c]{border-bottom:1px solid #e9e9e9;margin-bottom:12px;margin-top:12px;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.info-field td[data-v-7e69a01c]{padding:12px 0}.info-field-title[data-v-7e69a01c]{font-style:normal;font-weight:600;font-size:12px;line-height:16px;color:#272727;margin:0}.info-field-row[data-v-7e69a01c]{-ms-flex-item-align:center;align-self:center;width:80%;margin:0;padding-bottom:5px}.section-title[data-v-7e69a01c]{font-weight:700}select[data-v-7e69a01c]{width:210px;border:1px solid #ccc;border-radius:4px;-webkit-box-shadow:inset 0 1px 1px rgb(0 0 0/8%);box-shadow:inset 0 1px 1px rgb(0 0 0/8%)}textarea[data-v-7e69a01c]{height:200px}input[type=text][data-v-7e69a01c],textarea[data-v-7e69a01c]{max-height:300px;width:210px;border:1px solid #ccc;border-radius:4px;-webkit-box-shadow:inset 0 1px 1px rgb(0 0 0/8%);box-shadow:inset 0 1px 1px rgb(0 0 0/8%)}.arrow[data-v-7e69a01c]{border:solid #000;border-width:0 3px 3px 0;display:inline-block;width:4%;height:0;padding-bottom:4%}.right[data-v-7e69a01c]{transform:rotate(-45deg);-webkit-transform:rotate(-45deg)}.left[data-v-7e69a01c]{transform:rotate(135deg);-webkit-transform:rotate(135deg)}.photo[data-v-7e69a01c]{margin:0 auto;border-radius:4px;-o-object-fit:contain;object-fit:contain;width:88%;height:100%}.thumbnails[data-v-7e69a01c]{overflow-y:hidden;overflow-x:scroll;max-width:80%;margin:0 auto 20px}.blurred[data-v-7e69a01c]{opacity:.5;width:100%;height:37px}.selected[data-v-7e69a01c]{width:100%;height:50px}.problem-section[data-v-7e69a01c]{-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;-webkit-box-align:baseline;-ms-flex-align:baseline;align-items:baseline;width:100%}.icon-desc[data-v-7e69a01c]{white-space:pre;text-align:center}.selectedThumbnail[data-v-7e69a01c]{border:4px solid #34758e}.delete-image[data-v-7e69a01c]{width:15px;height:15px;cursor:pointer;position:relative;right:0;top:0;z-index:1}.thumbnail-container[data-v-7e69a01c]{position:relative;top:0;left:0;width:64px;height:64px;margin:5px}.thumbnail[data-v-7e69a01c]{width:64px;height:64px;margin:5px;-o-object-fit:cover;object-fit:cover;cursor:pointer;background:#34758e;position:absolute;top:0;left:0;z-index:0}.two-columns-template-modal[data-v-7e69a01c]{display:grid;grid-template-areas:\"form photos\";grid-template-columns:50% 50%}.problem-photos[data-v-7e69a01c]{grid-row-start:photos-start;grid-row-end:photos-end;grid-column-start:photos-start;grid-column-end:photos-end}.problem-form[data-v-7e69a01c]{grid-row-start:form-start;grid-row-end:form-end;grid-column-start:form-start;grid-column-end:form-end}@media (max-width:850px){.two-columns-template-modal[data-v-7e69a01c]{display:grid;grid-template-areas:\"form\" \"photos\";grid-template-columns:100%}}#photos-container[data-v-7e69a01c]{width:100%;-ms-flex-item-align:center;align-self:center}", "", {"version":3,"sources":["/Users/sleepingwarrior/BioControl/crfi-monitoring/UI/crfi_monitoring/src/components/Settings/Tasks/TaskProblemModal.vue"],"names":[],"mappings":"AACA,oCACI,mBAAoB,AACpB,iDAA0D,AAClD,yCAAkD,AAC1D,iBAAmB,CACtB,AACD,gCAEI,iBAAmB,CACtB,AACD,6BACI,gCAAiC,AACjC,mBAAoB,AACpB,gBAAiB,AACjB,wBAAyB,AACrB,qBAAsB,AAClB,sBAAwB,CACnC,AACD,gCACI,cAAgB,CACnB,AACD,mCACI,kBAAmB,AACnB,gBAAiB,AACjB,eAAgB,AAChB,iBAAkB,AAElB,cAAe,AACf,QAAU,CACb,AACD,iCACI,2BAA4B,AACxB,kBAAmB,AACvB,UAAW,AACX,SAAU,AACV,kBAAoB,CACvB,AACD,gCACI,eAAkB,CACrB,AACD,wBACI,YAAa,AACb,sBAAuB,AACvB,kBAAmB,AACnB,iDAAoD,AACpD,wCAA4C,CAC/C,AACD,0BACI,YAAc,CAOjB,AACD,4DAPI,iBAAkB,AAClB,YAAa,AACb,sBAAuB,AACvB,kBAAmB,AACnB,iDAAoD,AACpD,wCAA4C,CAS/C,AACD,wBACE,kBAAoB,AACpB,yBAA0B,AAC1B,qBAAsB,AACtB,SAAU,AACV,SAAU,AACV,iBAAmB,CACpB,AACD,wBACE,yBAA0B,AAC1B,gCAAkC,CACnC,AACD,uBACE,yBAA0B,AAC1B,gCAAkC,CACnC,AACD,wBACI,cAAsB,AACtB,kBAAmB,AACnB,sBAAuB,AACpB,mBAAoB,AACvB,UAAW,AACX,WAAa,CAChB,AACD,6BACI,kBAAmB,AACnB,kBAAmB,AACnB,cAAe,AACf,kBAAyB,CAC5B,AACD,0BACI,WAAa,AACb,WAAY,AACZ,WAAa,CAChB,AACD,2BACI,WAAY,AACZ,WAAa,CAChB,AACD,kCACI,yBAA0B,AACtB,sBAAuB,AACnB,8BAA+B,AACvC,2BAA4B,AACxB,wBAAyB,AACrB,qBAAsB,AAC9B,UAAY,CACf,AACD,4BACI,gBAAiB,AACjB,iBAAmB,CACtB,AACD,oCACI,wBAA0B,CAC7B,AACD,+BACI,WAAY,AACZ,YAAa,AACb,eAAgB,AAChB,kBAAmB,AACnB,QAAS,AACT,MAAO,AACP,SAAW,CACd,AACD,sCACI,kBAAmB,AACnB,MAAO,AACP,OAAQ,AACR,WAAY,AACZ,YAAa,AACb,UAAY,CACf,AACD,4BACI,WAAY,AACZ,YAAa,AACb,WAAY,AACZ,oBAAqB,AAClB,iBAAkB,AACrB,eAAgB,AAChB,mBAAoB,AACpB,kBAAmB,AACnB,MAAO,AACP,OAAQ,AACR,SAAW,CACd,AACD,6CACI,aAAc,AACd,kCAAmC,AACnC,6BAA+B,CAClC,AACD,iCACI,4BAAgC,AAChC,wBAA8B,AAC9B,+BAAgC,AAChC,0BAA8B,CACjC,AACD,+BACI,0BAA8B,AAC9B,sBAA4B,AAC5B,6BAA8B,AAC9B,wBAA4B,CAC/B,AACD,yBACA,6CACQ,aAAc,AACd,oCAAqC,AACrC,0BAA4B,CACnC,CACA,AACD,mCACI,WAAY,AACZ,2BAA4B,AACxB,iBAAmB,CAC1B","file":"TaskProblemModal.vue","sourcesContent":["\n.gallery-container[data-v-7e69a01c] {\n    background: #F9F9F9;\n    -webkit-box-shadow: 0px 0px 40px rgba(53, 110, 138, 0.25);\n            box-shadow: 0px 0px 40px rgba(53, 110, 138, 0.25);\n    border-radius: 5px;\n}\n.section-title[data-v-7e69a01c] {\n    font-weight: bold;\n    text-align: center;\n}\n.info-field[data-v-7e69a01c] {\n    border-bottom: 1px solid #E9E9E9;\n    margin-bottom: 12px;\n    margin-top: 12px;\n    -webkit-box-pack: center;\n        -ms-flex-pack: center;\n            justify-content: center;\n}\n.info-field td[data-v-7e69a01c] {\n    padding: 12px 0;\n}\n.info-field-title[data-v-7e69a01c] {\n    font-style: normal;\n    font-weight: 600;\n    font-size: 12px;\n    line-height: 16px;\n\n    color: #272727;\n    margin: 0;\n}\n.info-field-row[data-v-7e69a01c] {\n    -ms-flex-item-align: center;\n        align-self: center;\n    width: 80%;\n    margin: 0;\n    padding-bottom: 5px;\n}\n.section-title[data-v-7e69a01c] {\n    font-weight: bold;\n}\nselect[data-v-7e69a01c] {\n    width: 210px;\n    border: 1px solid #ccc;\n    border-radius: 4px;\n    -webkit-box-shadow: inset 0 1px 1px rgb(0 0 0 / 8%);\n    box-shadow: inset 0 1px 1px rgb(0 0 0 / 8%);\n}\ntextarea[data-v-7e69a01c] {\n    height: 200px; \n    max-height: 300px;\n    width: 210px;\n    border: 1px solid #ccc;\n    border-radius: 4px;\n    -webkit-box-shadow: inset 0 1px 1px rgb(0 0 0 / 8%);\n    box-shadow: inset 0 1px 1px rgb(0 0 0 / 8%);\n}\ninput[type=\"text\"][data-v-7e69a01c] {\n    max-height: 300px;\n    width: 210px;\n    border: 1px solid #ccc;\n    border-radius: 4px;\n    -webkit-box-shadow: inset 0 1px 1px rgb(0 0 0 / 8%);\n    box-shadow: inset 0 1px 1px rgb(0 0 0 / 8%);\n}\n.arrow[data-v-7e69a01c] {\n  border: solid black;\n  border-width: 0 3px 3px 0;\n  display: inline-block;\n  width: 4%;\n  height: 0;\n  padding-bottom: 4%;\n}\n.right[data-v-7e69a01c] {\n  transform: rotate(-45deg);\n  -webkit-transform: rotate(-45deg);\n}\n.left[data-v-7e69a01c] {\n  transform: rotate(135deg);\n  -webkit-transform: rotate(135deg);\n}\n.photo[data-v-7e69a01c] {\n    margin: 0 auto 0 auto;\n    border-radius: 4px;\n    -o-object-fit: contain;\n       object-fit: contain;\n    width: 88%;\n    height: 100%;\n}\n.thumbnails[data-v-7e69a01c] {\n    overflow-y: hidden;\n    overflow-x: scroll;\n    max-width: 80%;\n    margin: 0 auto 20px auto;\n}\n.blurred[data-v-7e69a01c] {\n    opacity: 0.5;\n    width: 100%;\n    height: 37px;\n}\n.selected[data-v-7e69a01c] {\n    width: 100%;\n    height: 50px;\n}\n.problem-section[data-v-7e69a01c] {\n    -webkit-box-pack: justify;\n        -ms-flex-pack: justify;\n            justify-content: space-between;\n    -webkit-box-align: baseline;\n        -ms-flex-align: baseline;\n            align-items: baseline;\n    width: 100%;\n}\n.icon-desc[data-v-7e69a01c] {\n    white-space: pre;\n    text-align: center;\n}\n.selectedThumbnail[data-v-7e69a01c] { \n    border: 4px solid #34758E;\n}\n.delete-image[data-v-7e69a01c] {\n    width: 15px;\n    height: 15px;\n    cursor: pointer;\n    position: relative;\n    right: 0;\n    top: 0;\n    z-index: 1;\n}\n.thumbnail-container[data-v-7e69a01c] { \n    position: relative;\n    top: 0;\n    left: 0;\n    width: 64px;\n    height: 64px;\n    margin: 5px;\n}\n.thumbnail[data-v-7e69a01c] {\n    width: 64px;\n    height: 64px;\n    margin: 5px;\n    -o-object-fit: cover;\n       object-fit: cover;\n    cursor: pointer;\n    background: #34758E;\n    position: absolute;\n    top: 0;\n    left: 0;\n    z-index: 0;\n}\n.two-columns-template-modal[data-v-7e69a01c] { \n    display: grid;\n    grid-template-areas: \"form photos\";\n    grid-template-columns: 50% 50%;\n}\n.problem-photos[data-v-7e69a01c] { \n    grid-row-start:    photos-start;\n    grid-row-end:      photos-end;\n    grid-column-start: photos-start;\n    grid-column-end:   photos-end;\n}\n.problem-form[data-v-7e69a01c] {\n    grid-row-start:    form-start;\n    grid-row-end:      form-end;\n    grid-column-start: form-start;\n    grid-column-end:   form-end;\n}\n@media (max-width: 850px){\n.two-columns-template-modal[data-v-7e69a01c] { \n        display: grid;\n        grid-template-areas: \"form\" \"photos\";\n        grid-template-columns: 100%;\n}\n}\n#photos-container[data-v-7e69a01c] {\n    width: 100%;\n    -ms-flex-item-align: center;\n        align-self: center;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 2264:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vertical grow gallery-container",staticStyle:{"width":"80vw","min-width":"400px","height":"100%"}},[_c('div',{staticClass:"two-columns-template-modal",staticStyle:{"margin-top":"5px"}},[_c('div',{staticClass:"problem-form"},[_c('div',{staticStyle:{"margin":"10px 20px"}},[_c('table',{staticStyle:{"width":"100%"}},[_c('tr',{staticClass:"info-field"},[_c('td',{staticClass:"info-field-title",staticStyle:{"text-align":"left"}},[_vm._v(_vm._s(_vm.$t('System')))]),_vm._v(" "),_c('td',{staticClass:"info-field-value",staticStyle:{"text-align":"right"}},[_vm._v(_vm._s(_vm.systemName))])]),_vm._v(" "),_c('tr',{staticClass:"info-field"},[_c('td',{staticClass:"info-field-title",staticStyle:{"text-align":"left"}},[_vm._v(_vm._s(_vm.$t('Device')))]),_vm._v(" "),_c('td',{staticClass:"info-field-value",staticStyle:{"text-align":"right"}},[_vm._v(_vm._s(_vm.selectedObject.deviceId))])]),_vm._v(" "),_c('tr',{staticClass:"info-field"},[_c('td',{staticClass:"info-field-title",staticStyle:{"text-align":"left"}},[_vm._v(_vm._s(_vm.$t('Title')))]),_vm._v(" "),_c('td',{staticClass:"info-field-value",staticStyle:{"text-align":"right"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedObject.title),expression:"selectedObject.title"}],staticStyle:{"width":"100%","padding":"10px"},attrs:{"type":"text","placeholder":_vm.$t('Title')},domProps:{"value":(_vm.selectedObject.title)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.selectedObject, "title", $event.target.value)}}})])]),_vm._v(" "),_c('tr',{staticClass:"info-field"},[_c('td',{staticClass:"info-field-title",staticStyle:{"text-align":"left"}},[_vm._v(_vm._s(_vm.$t('Description')))]),_vm._v(" "),_c('td',{staticClass:"info-field-value",staticStyle:{"text-align":"right"}},[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedObject.description),expression:"selectedObject.description"}],staticStyle:{"width":"100%","padding":"10px"},attrs:{"type":"text","placeholder":_vm.$t('Description')},domProps:{"value":(_vm.selectedObject.description)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.selectedObject, "description", $event.target.value)}}})])]),_vm._v(" "),_c('tr',{staticClass:"info-field"},[_c('td',{staticClass:"info-field-title",staticStyle:{"text-align":"left"}},[_vm._v(_vm._s(_vm.$t('Photos')))]),_vm._v(" "),_c('td',{staticClass:"info-field-value",staticStyle:{"text-align":"right"}},[_c('input',{attrs:{"type":"file","id":"problemPhotoId","name":"problemPhoto","accept":"image/*","multiple":""},on:{"change":function($event){$event.preventDefault();return _vm.addPhoto.apply(null, arguments)}}})])])])]),_vm._v(" "),_c('div',{staticClass:"horizontal",staticStyle:{"justify-content":"center","margin-bottom":"10px"}},[(_vm.error != '')?_c('div',{staticClass:"error"},[_vm._v(_vm._s(_vm.error))]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"problem-photos",staticStyle:{"background-color":"rgba(243, 243, 243, 1)"}},[_c('div',{staticStyle:{"margin":"auto"},attrs:{"id":"photos-container"}},[_c('div',{staticClass:"vertical",staticStyle:{"margin":"auto"}},[((_vm.photos.length > 0))?_c('div',{staticStyle:{"width":"calc(0.5 * 70vw)","height":"50vh","align-self":"center","text-align":"center","overflow":"hidden","white-space":"nowrap"}},[_c('i',{staticClass:"arrow left",style:([_vm.photos.length > 1 ? {'cursor': 'pointer' } : {'cursor': 'default'}]),on:{"click":function($event){return _vm.changePhoto(-1)}}}),_vm._v(" "),_c('img',{staticClass:"photo",attrs:{"src":_vm.photos[_vm.activePhotoIndex].url}}),_vm._v(" "),_c('i',{staticClass:"arrow right",style:([_vm.photos.length > 1 ? {'cursor': 'pointer' } : {'cursor': 'default'}]),on:{"click":function($event){return _vm.changePhoto(1)}}})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"thumbnails horizontal",staticStyle:{"padding-bottom":"10px"}},_vm._l((_vm.photos),function(photo,index){return _c('div',{key:index,on:{"click":function($event){_vm.activePhotoIndex = index}}},[_c('div',{staticClass:"thumbnail-container"},[_c('img',{staticClass:"delete-image",attrs:{"src":__webpack_require__(1688)},on:{"click":function($event){return _vm.deletePhoto(index)}}}),_vm._v(" "),_c('img',{staticClass:"thumbnail",class:{ selectedThumbnail: _vm.activePhotoIndex == index},attrs:{"src":photo.url}})])])}),0)])])])]),_vm._v(" "),_c('div',{staticStyle:{"align-self":"center","margin-bottom":"20px"}},[_c('Button',{staticStyle:{"width":"300px","align-self":"center"},attrs:{"title":_vm.$t('Save'),"buttonClass":"save-button semi-bold"},on:{"onClick":_vm.save}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 2265:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"view-container"},[_c('modal',{attrs:{"showDialog":_vm.modal == 'DISMISS',"title":_vm.$t('DISMISS_ALARMS')},on:{"close":_vm.close}},[_c('dismiss-alarm-modal',{attrs:{"system-id":_vm.systemId,"is-group":_vm.isSelectedGroup,"to-dismiss":_vm.selectedObject},on:{"dismissed":_vm.closeAndReload}})],1),_vm._v(" "),_c('modal',{attrs:{"showDialog":_vm.modal == 'DISMISSMANY',"title":_vm.$t('DISMISS_ALARMSMANY')},on:{"close":_vm.close}},[_c('dismiss-alarm-modal',{attrs:{"system-id":_vm.systemId,"is-group":_vm.isSelectedGroup,"is-many":true,"to-dismiss":_vm.selectedObject},on:{"dismissed":_vm.closeAndReload}})],1),_vm._v(" "),_c('modal',{attrs:{"showDialog":_vm.modal == 'PROBLEM',"title":_vm.$t('PROBLEM_ALARMS')},on:{"close":_vm.close}},[_c('task-problem-modal',{attrs:{"system-id":_vm.systemId,"task":_vm.selectedObject,"system-name":_vm.systemName},on:{"saved":_vm.saveAndReload}})],1),_vm._v(" "),_c('div',{staticClass:"max-grid"},[_c('ejs-grid',{ref:"grid",attrs:{"height":"100%","width":"100%","toolbar":_vm.toolbar,"toolbarClick":_vm.toolbarClick,"selectionSettings":_vm.selectionOptions,"allowTextWrap":false,"dataBound":_vm.dataBound,"dataSource":_vm.data,"allowPaging":true,"pageSettings":_vm.pageSettings,"allowFiltering":true,"filterSettings":_vm.filterOptions,"allowSorting":true,"allowMultiSorting":true,"allowPdfExport":true,"allowCsvExport":true,"allowExcelExport":true,"showBusyIndicator":true,"childGrid":_vm.childGrid,"rowDataBound":_vm.rowDataBound,"detailDataBound":_vm.onDetailDataBound}},[_c('e-columns',[_c('e-column',{attrs:{"type":"checkbox","width":"50","headerText":_vm.$t('Discontinued'),"textAlign":"Left","customAttributes":_vm.customAttributes,"canExport":false}}),_vm._v(" "),_c('e-column',{attrs:{"field":"createDate","headerText":_vm.$t('CreateDate'),"textAlign":"Left","customAttributes":_vm.customAttributes,"type":"dateTime","format":_vm.dateTimeFormatOptions,"filter":_vm.dateFilterOptions}}),_vm._v(" "),_c('e-column',{attrs:{"field":"priority","width":"150","headerText":_vm.$t('Priority'),"textAlign":"Left","customAttributes":_vm.customAttributes}}),_vm._v(" "),_c('e-column',{attrs:{"field":"alarmName","headerText":_vm.$t('AlarmName'),"template":_vm.TextTemplate,"textAlign":"Left","customAttributes":_vm.customAttributes}}),_vm._v(" "),_c('e-column',{attrs:{"field":"unitNumber","width":"150","headerText":_vm.$t('UnitNumber'),"textAlign":"Left","customAttributes":_vm.customAttributes}}),_vm._v(" "),_c('e-column',{attrs:{"field":"description","headerText":_vm.$t('Description'),"template":_vm.TextTemplate,"textAlign":"Left","customAttributes":_vm.customAttributes}}),_vm._v(" "),_c('e-column',{attrs:{"field":"endDateString","headerText":_vm.$t('EndDate'),"textAlign":"Left","customAttributes":_vm.customAttributes}}),_vm._v(" "),(!_vm.$store.getters.isUser)?_c('e-column',{attrs:{"headerText":_vm.$t('Options'),"width":"200px","template":_vm.optionsButtons,"customAttributes":_vm.customAttributes}}):_vm._e()],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/15.0d6f1af5855cc02dd782.js